var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Copyright (C) Microsoft. All rights reserved.
import { DefaultButton as FluentButton, PrimaryButton as FluentPrimaryButton, concatStyleSets, useTheme, } from "@fluentui/react";
import React from "react";
import { getBaseButtonStyle, getBaseDefaultButtonStyle } from "./Button.styles";
export const Button = (_a) => {
    var { primary = false, styles } = _a, rest = __rest(_a, ["primary", "styles"]);
    const theme = useTheme();
    return primary ? (React.createElement(FluentPrimaryButton, Object.assign({}, rest, { styles: concatStyleSets(getBaseButtonStyle(theme), getBaseDefaultButtonStyle(theme, primary), styles) }))) : (React.createElement(FluentButton, Object.assign({}, rest, { styles: concatStyleSets(getBaseButtonStyle(theme), getBaseDefaultButtonStyle(theme, primary), styles) })));
};
